export default __webpack_public_path__ + "static/media/selectSelected.c2b07f32.svg";